import React, { useEffect, useState } from "react";
import Header from "../Presale/Header";
import Footer from "../Footer";
import "../css/blog.css";
import { Container, Row, Col, div, Button } from "react-bootstrap";
import { FaArrowRightLong } from "react-icons/fa6";
import { getAllBlogsAction } from "../../../services/apiServices";
import { useNavigate } from 'react-router-dom';
import config from '../../../config'
import Blogdetail from "../Blogdetail";

const Blog = () => {
  const navigate = useNavigate();
  const [blog, setAllBlogs] = useState([]);
  useEffect(() => {
    getAllBlog();
  }, []);

  const getAllBlog = async () => {
    let res = await getAllBlogsAction();
    console.log(res, "response");
    if (res) {
      setAllBlogs(res.data.data);
    } else {
      setAllBlogs([]);
    }
  };

  const handleClick = (e, item) => {
    e.preventDefault()
    console.log(item, "itemitemitem");
    navigate(`${config.baseurl}Blogdetail/${item.idPrimary}`);
  };

  return (
    <>
      <Header />
      <section className="bg-dark py-5 blogbanner">
        <Container>
          <Row>
            <Col lg={12} className="text-center">
              <div className="heading position-relative z-1">
                <h1 class="text-primary">
                  <b>Blog</b>
                </h1>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="banner-background-overlay"></div>
      </section>
      <section className="py-5">
        <Container>
          <div className="blog-container">
            <Row>
              {blog.length > 0 &&
                blog?.map((item) => (
                  <Col lg={4} className="mb-5">

                    <div className="blog-post overflow-hidden">
                      <div className="blog-thumb">
                        <a href={item?._image} target="_blank">
                          <img src={item?._image} />
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-post-category"></div>
                        <h4 className="blog-post-title">{item?._title}</h4>
                        <div className="blog-post-excerpt">
                          {/* <p
                            className="text-grey"
                            dangerouslySetInnerHTML={{
                             __html:
                                  item.description.length > 100
                                    ? item.description.slice(0, 100) + "......."
                                    : item.description,
                            }}
                          ></p> */}
                          {/* 
dangerouslySetInnerHTML={{
                                __html:
                                  item.description.length > 100
                                    ? item.description.slice(0, 100) + "......."
                                    : item.description,
                              }} */}
                        </div>
                        <div className="blog-readmore mt-4">
                          <Button
                            variant="outline-primary"
                            type="button"
                            class="text-uppercase fs-6"
                            onClick={(e) => handleClick(e, item)}
                          >
                            Read More <FaArrowRightLong />
                          </Button>
                        </div>
                      </div>
                    </div>

                  </Col>
                ))}
            </Row>
          </div>
        </Container>
      </section>

      {/* <Container>
                <hr className='mt-0 mb-0' />
            </Container> */}
      <Footer className="pt-0" />
    </>
  );
};

export default Blog;
